import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../shared/services//http/auth/auth.service';
import { ClientService } from '../shared/services/client.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedGuard implements CanActivate {
  constructor(private authService: AuthService,private router:Router,private clientService: ClientService){

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      // Get client from URL
      // const client = route.paramMap.get('client');
      
      if (this.authService.getToken()) {
        let userDetails = this.authService.getDataFromLocalStorage('user_details');
        userDetails = JSON.parse(userDetails);

        const storedClient = this.clientService.getCurrentClient();

        if (userDetails?.type == 'teacher') {
          this.router.navigate([storedClient, 'teacher', 'dashboard']);
        }
        else if (userDetails?.type == 'institute') {
          this.router.navigate([storedClient, 'institute', 'dashboard']);
        }
        else {
          this.router.navigate([storedClient, 'auth', 'login']);
        }
        return false;
      } else {
        return true;
      }
  }
  
}


